module.exports = __webpack_public_path__ + "static/img/icon_logo.e5ce3f69.png";